import {useEffect} from "react";
import {getWorkbox} from "@sfs/utils/workbox";
import {useTranslation} from "react-i18next";
import {AppMethods} from "./useThemedAppMethods";

export const useRegisterServiceWorker = () => {
  const {t} = useTranslation();

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;

    const wb = getWorkbox();
    if (!wb) return;

    // Event listener when loading a new service worker -> notify user and skip waiting
    wb.addEventListener("waiting", () => {
      AppMethods.message.loading(t("common:pwa.newVersionAvailable"));
      // Ask waiting SW to skip waiting
      wb.messageSW({type: "SKIP_WAITING"});
    });

    // Event listener when new service worker is controlling the page -> reload
    let refreshing = false;
    wb.addEventListener("controlling", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });

    wb.register();
  }, []);
};
